var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Ds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 510 510"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f73a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__c",
    x1: 169.641,
    x2: 338.308,
    y1: 156.642,
    y2: 325.309,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__d",
    x1: 70.973,
    x2: 239.639,
    y1: 255.311,
    y2: 423.977,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__e",
    x1: 317.644,
    x2: 486.31,
    y1: 8.639,
    y2: 177.306,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__f",
    x1: 120.307,
    x2: 288.973,
    y1: 205.976,
    y2: 374.643,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__g",
    x1: 218.975,
    x2: 387.642,
    y1: 107.308,
    y2: 275.974,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__h",
    x1: 239.236,
    x2: 407.902,
    y1: 87.047,
    y2: 255.714,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__i",
    x1: 279.412,
    x2: 448.079,
    y1: 46.871,
    y2: 215.537,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__j",
    x1: 264.063,
    x2: 432.73,
    y1: 62.22,
    y2: 230.887,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__k",
    x1: 306.197,
    x2: 474.863,
    y1: 20.087,
    y2: 188.753,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__l",
    x1: 266.02,
    x2: 434.687,
    y1: 60.263,
    y2: 228.93,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__m",
    x1: 112.358,
    x2: 281.025,
    y1: 213.925,
    y2: 382.592,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__n",
    x1: 213.22,
    x2: 381.887,
    y1: 113.063,
    y2: 281.73,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__o",
    x1: -22.004,
    x2: 146.663,
    y1: 348.287,
    y2: 516.954,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__p",
    x1: 27.331,
    x2: 195.997,
    y1: 298.953,
    y2: 467.619,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__q",
    x1: 347.582,
    x2: 516.249,
    y1: -21.299,
    y2: 147.368,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__r",
    x1: 298.248,
    x2: 466.915,
    y1: 28.035,
    y2: 196.702,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__s",
    x1: 87.047,
    x2: 255.714,
    y1: 239.236,
    y2: 407.902,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__t",
    x1: 46.871,
    x2: 215.537,
    y1: 279.412,
    y2: 448.079,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__u",
    x1: 20.087,
    x2: 188.753,
    y1: 306.197,
    y2: 474.863,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__v",
    x1: 60.263,
    x2: 228.93,
    y1: 266.02,
    y2: 434.687,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__w",
    x1: 62.22,
    x2: 230.887,
    y1: 264.063,
    y2: 432.73,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__x",
    x1: 255.311,
    x2: 423.977,
    y1: 70.973,
    y2: 239.639,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__y",
    x1: 107.308,
    x2: 275.974,
    y1: 218.975,
    y2: 387.642,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__z",
    x1: 8.639,
    x2: 177.306,
    y1: 317.644,
    y2: 486.31,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__A",
    x1: 205.976,
    x2: 374.643,
    y1: 120.307,
    y2: 288.973,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__B",
    x1: 156.642,
    x2: 325.309,
    y1: 169.641,
    y2: 338.308,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__a"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__C",
    x1: 295.61,
    x2: 415.901,
    y1: 296.987,
    y2: 417.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45a2e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__D",
    x1: 129.871,
    x2: 269.897,
    y1: 257.19,
    y2: 397.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45a2e0"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__E",
    x1: 207.844,
    x2: 359.045,
    y1: 112.756,
    y2: 263.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7acbff"
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#174461",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__F",
    x1: 255,
    x2: 255,
    y1: 359.751,
    y2: 82.82,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__b"
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__G",
    x1: 307.088,
    x2: 141.346,
    y1: 180.432,
    y2: 101.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__H",
    x1: 127.886,
    x2: 203.886,
    y1: 374.541,
    y2: 220.541,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__b"
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__I",
    x1: -1125.656,
    x2: -1049.656,
    y1: 374.541,
    y2: 220.541,
    gradientTransform: "matrix(-1 0 0 1 -743.97 0)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__b"
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3ds_svg__J",
    x1: -3559.593,
    x2: -3483.593,
    y1: -1835.792,
    y2: -1989.792,
    gradientTransform: "scale(-1 1) rotate(-60.2 -106.6 -3688.814)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3ds_svg__b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__c)",
    d: "M132.69 146.649a7.194 7.194 0 003.587-.958l25.091-14.377a7.23 7.23 0 00-7.188-12.546l-25.091 14.377a7.229 7.229 0 003.601 13.504z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__d)",
    d: "M28.727 190.653L3.637 205.03a7.229 7.229 0 003.6 13.504 7.194 7.194 0 003.587-.958l25.091-14.377c3.465-1.985 4.664-6.402 2.679-9.867s-6.403-4.665-9.867-2.679z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__e)",
    d: "M320.869 38.823a7.194 7.194 0 003.587-.958l25.091-14.376a7.229 7.229 0 002.679-9.867 7.23 7.23 0 00-9.867-2.679l-25.091 14.376a7.229 7.229 0 003.601 13.504z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__f)",
    d: "M101.32 157.389a7.228 7.228 0 00-9.285-2.974l-18.484-10.591a7.23 7.23 0 00-7.188 12.545l11.098 6.359-11.098 6.359a7.229 7.229 0 003.6 13.504 7.197 7.197 0 003.587-.958l18.495-10.597a7.186 7.186 0 002.996.669 7.227 7.227 0 006.279-3.637 7.199 7.199 0 00.737-5.339 7.193 7.193 0 00-.737-5.34z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__g)",
    d: "M189.137 107.07a7.227 7.227 0 009.866 2.679l25.091-14.376c3.465-1.985 4.664-6.402 2.679-9.867s-6.403-4.664-9.867-2.679l-25.091 14.376a7.23 7.23 0 00-2.678 9.867z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__h)",
    d: "M160.453 23.488l25.091 14.376a7.227 7.227 0 009.866-2.679 7.23 7.23 0 00-2.679-9.867L167.64 10.942a7.23 7.23 0 00-7.187 12.546z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__i)",
    d: "M380.911 133.146l-25.091-14.377a7.23 7.23 0 10-7.188 12.546l25.091 14.377a7.227 7.227 0 009.866-2.679 7.23 7.23 0 00-2.678-9.867z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__j)",
    d: "M223.179 59.43l25.091 14.377a7.2 7.2 0 003.587.958 7.251 7.251 0 003.143-.733c.98.472 2.052.733 3.143.733a7.197 7.197 0 003.587-.958l25.091-14.377a7.229 7.229 0 10-7.188-12.545L255 60.999l-24.633-14.115a7.23 7.23 0 10-7.188 12.546z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__k)",
    d: "M474.085 203.198l25.091 14.377a7.227 7.227 0 009.866-2.679 7.23 7.23 0 00-2.679-9.867l-25.091-14.377a7.23 7.23 0 10-7.187 12.546z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__l)",
    d: "M283.227 85.505a7.23 7.23 0 002.679 9.867l25.091 14.376a7.227 7.227 0 009.866-2.679 7.23 7.23 0 00-2.679-9.867l-25.091-14.376a7.23 7.23 0 00-9.866 2.679z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__m)",
    d: "M35.915 122.259l-25.091-14.376a7.229 7.229 0 00-9.867 2.679 7.23 7.23 0 002.679 9.867l25.091 14.376a7.227 7.227 0 009.866-2.679 7.228 7.228 0 00-2.678-9.867z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__n)",
    d: "M506.363 390.983l-25.091-14.377a7.23 7.23 0 10-7.188 12.546l25.091 14.377a7.227 7.227 0 009.866-2.679 7.228 7.228 0 00-2.678-9.867z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__o)",
    d: "M32.315 375.648a7.194 7.194 0 00-3.587.958L3.637 390.982c-3.465 1.985-4.664 6.402-2.679 9.867s6.403 4.665 9.867 2.679l25.091-14.376a7.229 7.229 0 00-3.601-13.504z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__p)",
    d: "M101.32 343.342a7.227 7.227 0 00-6.279-3.637c-.476 0-.953.062-1.427.158l-20.063-11.496a7.227 7.227 0 00-9.866 2.679 7.23 7.23 0 002.679 9.867l12.328 7.064-12.328 7.064a7.229 7.229 0 107.188 12.545l20.051-11.489a7.23 7.23 0 007.719-3.486 7.189 7.189 0 00.876-4.634 7.205 7.205 0 00-.878-4.635z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__q)",
    d: "M481.273 134.804l25.091-14.377a7.229 7.229 0 00-3.6-13.504 7.194 7.194 0 00-3.587.958l-25.091 14.377a7.229 7.229 0 00-2.679 9.867 7.228 7.228 0 009.866 2.679z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__r)",
    d: "M446.316 146.503a7.227 7.227 0 00-9.866-2.679l-18.484 10.591a7.228 7.228 0 00-9.285 2.974 7.199 7.199 0 00-.737 5.339 7.199 7.199 0 00.737 5.339 7.228 7.228 0 009.285 2.974l18.484 10.591a7.227 7.227 0 009.866-2.679 7.23 7.23 0 00-2.679-9.867l-11.098-6.359 11.098-6.359a7.226 7.226 0 002.679-9.865z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__s)",
    d: "M349.547 486.512l-25.091-14.376a7.227 7.227 0 00-9.866 2.679 7.23 7.23 0 002.679 9.867l25.091 14.376a7.23 7.23 0 007.187-12.546z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__t)",
    d: "M164.047 388.553a7.23 7.23 0 00-2.679-9.867l-25.091-14.377a7.227 7.227 0 00-9.866 2.679 7.23 7.23 0 002.679 9.867l25.091 14.377a7.23 7.23 0 009.866-2.679z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__u)",
    d: "M35.915 306.802l-25.091-14.377a7.227 7.227 0 00-9.866 2.679 7.23 7.23 0 002.679 9.867l25.091 14.377a7.23 7.23 0 107.187-12.546z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__v)",
    d: "M226.773 424.495a7.23 7.23 0 00-2.679-9.867l-25.091-14.376a7.227 7.227 0 00-9.866 2.679 7.23 7.23 0 002.679 9.867l25.091 14.376a7.23 7.23 0 009.866-2.679z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__w)",
    d: "M286.821 450.57l-25.091-14.377a7.2 7.2 0 00-3.587-.958 7.251 7.251 0 00-3.143.733 7.251 7.251 0 00-3.143-.733 7.197 7.197 0 00-3.587.958l-25.091 14.377a7.229 7.229 0 107.188 12.545L255 449.001l24.633 14.115a7.23 7.23 0 107.188-12.546z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__x)",
    d: "M481.273 319.347l25.091-14.377a7.229 7.229 0 00-3.6-13.504 7.194 7.194 0 00-3.587.958l-25.091 14.377a7.229 7.229 0 00-2.679 9.867 7.227 7.227 0 009.866 2.679z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__y)",
    d: "M320.863 402.93a7.227 7.227 0 00-9.866-2.679l-25.091 14.376c-3.465 1.985-4.664 6.402-2.679 9.867s6.403 4.664 9.867 2.679l25.091-14.376a7.23 7.23 0 002.678-9.867z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__z)",
    d: "M189.131 471.177a7.194 7.194 0 00-3.587.958l-25.091 14.376c-3.465 1.985-4.664 6.402-2.679 9.867s6.403 4.665 9.867 2.679l25.091-14.376a7.229 7.229 0 00-3.601-13.504z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__A)",
    d: "M446.316 331.046a7.227 7.227 0 00-9.866-2.679l-20.051 11.489a7.23 7.23 0 00-7.718 3.486 7.189 7.189 0 00-.876 4.634 7.189 7.189 0 00.876 4.634 7.228 7.228 0 007.718 3.486l20.051 11.489a7.227 7.227 0 009.866-2.679 7.23 7.23 0 00-2.679-9.867l-12.328-7.064 12.328-7.064a7.226 7.226 0 002.679-9.865z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__B)",
    d: "M377.31 363.351a7.194 7.194 0 00-3.587.958l-25.091 14.377a7.23 7.23 0 007.188 12.546l25.091-14.377a7.229 7.229 0 00-3.601-13.504z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__C)",
    d: "M418.986 161.156l-144.164 82.62a39.864 39.864 0 01-39.645 0l-144.164-82.62a52.198 52.198 0 00-7.089 26.289v135.383a52.198 52.198 0 007.089 26.289c4.554 7.852 11.126 14.474 19.249 19.151l118.694 68.012a52.326 52.326 0 0026.043 6.941 52.356 52.356 0 0026.067-6.941l118.669-68.012a52.24 52.24 0 0019.249-19.151 52.198 52.198 0 007.089-26.289V187.445a52.179 52.179 0 00-7.087-26.289z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__D)",
    d: "M235.178 243.777l-144.164-82.62a52.198 52.198 0 00-7.089 26.289v135.383a52.198 52.198 0 007.089 26.289c4.554 7.852 11.126 14.474 19.249 19.151l118.694 68.012A52.326 52.326 0 00255 443.222V249.054a39.84 39.84 0 01-19.822-5.277z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__E)",
    d: "M418.986 161.156l-146.995 84.243a34.172 34.172 0 01-33.981 0L91.014 161.156c4.554-7.852 11.126-14.474 19.249-19.151l118.694-68.012c16.123-9.255 35.963-9.255 52.11 0l118.669 68.012a52.25 52.25 0 0119.25 19.151z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__F)",
    d: "M418.986 349.117a52.248 52.248 0 01-19.249 19.151L281.068 436.28a52.348 52.348 0 01-26.067 6.941 52.337 52.337 0 01-26.043-6.941l-118.694-68.012c-8.123-4.677-14.695-11.298-19.249-19.151L238.54 264.57a33.102 33.102 0 0132.919 0z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__G)",
    d: "M399.737 142.006L281.068 73.994a52.378 52.378 0 00-26.061-6.941v182.87a34.153 34.153 0 0016.984-4.523l146.995-84.243a52.24 52.24 0 00-19.249-19.151z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__H)",
    d: "M84.75 359.799a7.23 7.23 0 01-3.6-13.504l25.091-14.376a7.229 7.229 0 019.867 2.679 7.23 7.23 0 01-2.679 9.867l-25.091 14.376a7.206 7.206 0 01-3.588.958zm62.726-35.942a7.23 7.23 0 01-3.6-13.504l25.091-14.377a7.23 7.23 0 017.188 12.545l-25.091 14.377a7.181 7.181 0 01-3.588.959zm62.727-35.942a7.23 7.23 0 01-3.6-13.504l25.091-14.376a7.229 7.229 0 019.867 2.679 7.23 7.23 0 01-2.679 9.867l-25.091 14.376a7.206 7.206 0 01-3.588.958z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__I)",
    d: "M421.235 358.841l-25.091-14.376c-3.465-1.985-4.664-6.402-2.679-9.867s6.403-4.664 9.867-2.679l25.091 14.376a7.229 7.229 0 01-3.6 13.504 7.2 7.2 0 01-3.588-.958zm-62.726-35.942l-25.091-14.377a7.229 7.229 0 117.188-12.545l25.091 14.377a7.229 7.229 0 01-3.6 13.504 7.197 7.197 0 01-3.588-.959zm-62.727-35.942l-25.091-14.376c-3.465-1.985-4.664-6.402-2.679-9.867s6.403-4.665 9.867-2.679l25.091 14.376a7.229 7.229 0 01-3.6 13.504 7.2 7.2 0 01-3.588-.958z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3ds_svg__J)",
    d: "M247.779 253.226l-.003-28.918a7.228 7.228 0 017.228-7.23 7.228 7.228 0 017.23 7.228l.003 28.918a7.228 7.228 0 01-7.228 7.23 7.23 7.23 0 01-6.278-3.639 7.184 7.184 0 01-.952-3.589zm-.007-72.294l-.003-28.918a7.229 7.229 0 017.229-7.23 7.231 7.231 0 017.23 7.229l.003 28.918a7.228 7.228 0 01-7.228 7.23 7.23 7.23 0 01-7.231-7.229zm-.006-72.294l-.003-28.918a7.228 7.228 0 017.228-7.23 7.228 7.228 0 017.23 7.228l.003 28.918a7.228 7.228 0 01-7.228 7.23 7.23 7.23 0 01-6.278-3.639 7.195 7.195 0 01-.952-3.589z"
  })));
}
export default __webpack_public_path__ + "static/3ds.50ad3a46.svg";
export { Svg3Ds as ReactComponent };